import styles from "./style.module.scss";
import cx from "classnames";

type FooterPageNumberProps = {
  totalPages: number;
  currentPage: number;
  forcePageBreak?: boolean;
};

const FooterPageNumber = (props: FooterPageNumberProps) => {
  const { currentPage, totalPages, forcePageBreak = false } = props;

  return (
    <>
      <div className={cx({
        [styles.pageBreak]: true,
        [styles.printBreak]: totalPages !== currentPage || forcePageBreak,
      })}>
        Pag {currentPage} de {totalPages} </div>
    </>
  );
};

export default FooterPageNumber;